import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/logo/logo1.png';
const _hoisted_1 = {
  key: 0,
  class: "header"
};
const _hoisted_2 = {
  class: "header_content"
};
const _hoisted_3 = {
  class: "header_left"
};
import axios from 'axios';
import { ref, onMounted, reactive, getCurrentInstance, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
export default {
  __name: 'Header',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const time = ref('');
    const day = ref('');
    const moment = ref('');
    const activeIndex = ref('1');
    const scrollTop = ref(0);
    const data = reactive({
      schemeList: []
    });
    const baseUrl = getCurrentInstance().appContext.config.globalProperties.baseUrl;
    onMounted(() => {
      scrollTop.value = 0;
      getSchemeList();
      if (route.path == '/') {
        activeIndex.value = '1';
      } else if (route.path == '/aboutUs') {
        activeIndex.value = '2-1';
      } else if (route.path == '/qualificationCertificate') {
        activeIndex.value = '2-3';
      } else if (route.path == '/productList') {
        activeIndex.value = '3';
      } else if (route.path == '/application') {
        activeIndex.value = '4-1';
      } else if (route.path == '/newsList') {
        activeIndex.value = '5';
      } else if (route.path == '/laboratory') {
        activeIndex.value = '6';
      } else {
        activeIndex.value = '';
      }
      getMonth();
    });
    const handleScroll = event => {
      scrollTop.value = event.scrollTop;
      console.log(event);
    };
    const getSchemeList = url => {
      axios.get(`${baseUrl}/lechi/cms/article/list?pageNum=1&pageSize=6&articleType=scheme`, {}).then(res => {
        if (res.data.code == 200) {
          data.schemeList = res.data.rows;
        }
      }).catch(error => {});
    };
    const handleApp = id => {
      router.push({
        path: `/application${id}`
        // query:{
        //   id: id
        // }
      });
    };
    const getMonth = () => {
      let date = new Date();
      let m = new Date().getMonth() + 1;
      let d = new Date().getDate();
      day.value = `${m}月${d}日`;
    };
    setInterval(() => {
      var date = new Date();
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      time.value = hh + mm + ss;
      const hours = date.getHours();
      if (hours < 12) {
        moment.value = '上午';
      } else {
        moment.value = '下午';
      }
    }, 1000);
    return (_ctx, _cache) => {
      const _component_el_affix = _resolveComponent("el-affix");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_affix, {
        class: "affix",
        onScroll: handleScroll
      }), scrollTop.value < 60 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "logo_div"
      }, [_createElementVNode("img", {
        class: "logo",
        src: _imports_0
      })], -1)), _createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "header-menu",
        mode: "horizontal",
        "text-color": "#2c3045"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "1"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: '/'
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("首页")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "3"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: '/productList'
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("产品技术")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "4"
        }, {
          title: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("系统方案")])),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.schemeList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_menu_item, {
              key: item.id,
              index: index,
              onClick: $event => handleApp(index + 1)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
              _: 2
            }, 1032, ["index", "onClick"]);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "6"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: '/laboratory'
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("实验室")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "5"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: '/newsList'
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("新闻中心")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "2"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: '/aboutUs'
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("公司简介")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active"])])])])) : _createCommentVNode("", true)], 64);
    };
  }
};